// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { visitTableTitles } from '../../../utils/constants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const parseStatuses = (filterRow) => {
  if (!filterRow) return []

  return (
    filterRow
      .split('&')
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      .map((segment) => {
        const match = segment.match(/Statuses\[(\d+)\]=(.*)/)
        if (match) {
          // decodeURIComponent in case the status has special chars/spaces
          return decodeURIComponent(match[2])
        }
        return null
      })
      .filter(Boolean)
  ) // remove null entries
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const buildFilterRowFromStatuses = (statuses) =>
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  statuses.map((status, i) => `Statuses[${i}]=${encodeURIComponent(status)}`).join('&')

const VisitsTableFiltersWrapper = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  FilterComponent,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isShowFilterComponent,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  filterPosition,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setVisitsListToShow,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setVisitTypesFilterRow,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setStatusFilterRow,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitsListToShow,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  title,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  closeRemarks,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  tableView,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitTypesFilterRow,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  statusFilterRow,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setStatusTagRow,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  tagFilterRow,
}) => {
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const loading = useSelector((state) => state.visitsReducer.loading)

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const correctFilterCallback = (titleName, newFilterRow) => {
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    setVisitsListToShow((prev) =>
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      prev.map((visit) => (visit.title === titleName ? { ...visit, isFilterActive: !!newFilterRow } : visit)),
    )

    switch (titleName) {
      case visitTableTitles.VISIT: {
        setVisitTypesFilterRow(newFilterRow)
        if (newFilterRow || visitTypesFilterRow) {
          closeRemarks()
        }
        break
      }

      case visitTableTitles.STATUS: {
        const existingStatuses = parseStatuses(statusFilterRow)

        const newStatuses = parseStatuses(newFilterRow)

        const combined = Array.from(new Set([...existingStatuses, ...newStatuses]))

        if (combined.includes('inwaitingroom') && !combined.includes('inwaitingroomback')) {
          combined.push('inwaitingroomback')
        }

        const finalFilterRow = buildFilterRowFromStatuses(combined)

        setStatusFilterRow(finalFilterRow)

        if (finalFilterRow || statusFilterRow) {
          closeRemarks()
        }
        break
      }
      case visitTableTitles.TAGS: {
        setStatusTagRow(newFilterRow)
        if (newFilterRow || tagFilterRow) {
          closeRemarks()
        }
        break
      }
      default:
        return () => {}
    }
  }

  const onCloseFilterSettings = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (e) => {
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const openedFilter = visitsListToShow.find((t) => t?.isShowFilterComponent)
      if (e?.target?.id === `filterImg${openedFilter?.title}`) {
        e.stopPropagation()
      }

      if (!(e?.target?.classList?.[0] === 'loading-container')) {
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        setVisitsListToShow((prev) => prev.map((visitObj) => ({ ...visitObj, isShowFilterComponent: false })))
      }
    },
    [setVisitsListToShow, visitsListToShow],
  )

  return (
    <div>
      {FilterComponent && isShowFilterComponent ?
        <FilterComponent
          tableView={tableView}
          filterPosition={filterPosition}
          onCloseFilterSettings={onCloseFilterSettings}
          loading={loading}
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          setFilterRow={(newFilterRow) => correctFilterCallback(title, newFilterRow)}
        />
      : null}
    </div>
  )
}

export default VisitsTableFiltersWrapper
